// extracted by mini-css-extract-plugin
export default {"mineCrew":"styles_mineCrew__jTF4h","mineCrewTable":"styles_mineCrewTable__rSlJG","contractors":"styles_contractors__JH-2o"};